import produce from "immer";
import { PaymentMethod } from "@Types/cart";
import { CartState } from "../";

export interface SetSelectedPaymentMethodAction {
  paymentMethod: PaymentMethod | undefined;
  type: "setSelectedPaymentMethod";
}

export const setSelectedPaymentMethod = (
  state: CartState,
  action: SetSelectedPaymentMethodAction
): CartState => {
  return produce(state, (draftState) => {
    draftState.selectedPaymentMethod = action.paymentMethod;
  });
};
